/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  OrganizationDetailsResponse,
  OrganizationUpdateCommercialConditions,
  OrganizationUpdateRequestDataWithFiles,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class SignupRequests<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags public-organization-controller
   * @name UpdateOrganization
   * @request PATCH:/signupRequests/{organizationId}
   * @secure
   * @response `200` `OrganizationDetailsResponse` OK
   */
  updateOrganization = (
    organizationId: string,
    data: OrganizationUpdateRequestDataWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<OrganizationDetailsResponse, any>({
      path: `/signupRequests/${organizationId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags public-organization-controller
   * @name UpdateOrganizationCommercialConditions
   * @request PATCH:/signupRequests/{organizationId}/commercialConditions
   * @secure
   * @response `200` `OrganizationDetailsResponse` OK
   */
  updateOrganizationCommercialConditions = (
    organizationId: string,
    data: OrganizationUpdateCommercialConditions,
    params: RequestParams = {},
  ) =>
    this.request<OrganizationDetailsResponse, any>({
      path: `/signupRequests/${organizationId}/commercialConditions`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
